import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./CreateNurse.css";
import { useTranslation } from "react-i18next";
import Widgets from "../../../../widgets";
import SelectCard from "../../../../widgets/selectCard/selectCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { postNurse, getAllServices, getSubServices, getServiceItems } from "../../../../modules/NursignCare/ManageNurse/ManageNurseThunk";
import { resetPostNurse } from "../../../../modules/NursignCare/ManageNurse/ManageNurseSlice";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import Icons from "../../../../Assets/Icons/index";
import ProgressBarDynamic from "../../../../widgets/ProgressBarforMangeNurse/ProgressBarDynamic";
import Select from "react-select";
import MultiSelector from "../../../../widgets/SelectDropdown/MultiSelector";
import ToastPopup from "../../../../widgets/Toast/toastPopup";
import useValidation from "../../../../utils/validators";
import strings from "../../../../utils/strings";
import { useNavigate } from "react-router-dom";
import { uploadMedia } from "../../../../modules/patientProfile/patientProfileThunk";

const CreateNurse = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { validateCretaeNurse } = useValidation();

  const extractString = (val) => {
    if (val && typeof val === "object" && !Array.isArray(val)) {
      return val[i18n.language] || val.en || val.vi || "";
    }
    return val || "";
  };
  const breadcrumbs = [t("nursing_care"), t("manage_nurse"), t("create_nurse")];
  const paths = [strings.navigation.nurseList, strings.navigation.nurseList, strings.navigation.createNurse];
  const [isOn, setIsOn] = useState(false);
  const { postNurseSuccess, postNurseErr } = useSelector((state) => state.manageNurse);
  const [errors, setErrors] = useState({});
  const [progress, setProgress] = useState(0);
  const [serviceGroupOptions, setServiceGroupOptions] = useState([]);
  const [subServiceGroupOptions, setSubServiceGroupOptions] = useState([]);
  const [serviceItemsOptions, setServiceItemsOptions] = useState([]);
  const [selectedServiceGroups, setSelectedServiceGroups] = useState([]);
  const [selectedServiceItems, setSelectedServiceItems] = useState([]);
  const [selectedSubServiceGroups, setSelectedSubServiceGroups] = useState([]);
  const [isPhotoUploaded, setIsPhotoUploaded] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [isPhotoUploading, setIsPhotoUploading] = useState(false);
  const [serviceGroups, setServiceGroups] = useState([{ id: 1, serviceGroup: "", subServiceGroup: "", serviceItems: "" }]);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [showActivateModal, setShowActivateModal] = useState(false);
  // const [inactiveRange, setInactiveRange] = useState({ startDate: "", endDate: "" });

  const [selectedLang, setSelectedLang] = useState({ value: "EN", label: t("English") });
  const langOptions = [
    { value: "VI", label: t("vietnamese") },
    { value: "EN", label: t("english") },
  ];

  const designationOptions = [
    { value: "nurse", label: t("nurse") },
  ];

  const [nurseData, setNurseData] = useState({
    firstName: { en: "", vi: "" },
    lastName: { en: "", vi: "" },
    passportNumber: "123456789", // Default value for validation purposes
    email: "",
    countryCode: "91",
    alpha2code: "IN",
    employeeID: "",
    phoneNumber: "",
    dateOfBirth: "",
    gender: "",
    languages: [],
    designation: { en: "", vi: "" },
    address: { en: "", vi: "" },
    profilePhoto: "",
    // isActive: isOn,
  });

  useEffect(() => {
    // Fetch all services when the component mounts
    dispatch(getAllServices())
      .unwrap()
      .then((response) => {
        const serviceOptions = response.data.services.map((service) => ({
          value: service._id,
          label: extractString(service.title),
        }));
        setServiceGroupOptions(serviceOptions);
      })
      .catch((error) => {
        console.error("Error fetching services:", error);
      });
  }, [dispatch]);

  useEffect(() => {
    if (postNurseErr) {
      ToastPopup.error(postNurseErr);
    }
    if (postNurseSuccess && postNurseSuccess.status === "success") {
      ToastPopup.success(t("nurseCreatedSuccessfully"));
      navigate(strings.navigation.nurseList);
    }
    dispatch(resetPostNurse());
  }, [postNurseSuccess, postNurseErr]);

  const handleServiceGroupChange = (selectedOptions) => {
    setSelectedServiceGroups(selectedOptions);
    // Fetch sub-services for all selected service groups
    const serviceIds = selectedOptions.map((option) => option.value);
    Promise.all(serviceIds.map((serviceId) => dispatch(getSubServices(serviceId)).unwrap()))
      .then((responses) => {
        const allSubServices = responses.flatMap((response) =>
          response.data.subServices.map((subService) => ({
            value: subService._id,
            label: extractString(subService.title),
          })),
        );
        // Remove duplicates
        const uniqueSubServices = Array.from(new Set(allSubServices.map((s) => s.value))).map((value) => allSubServices.find((s) => s.value === value));
        setSubServiceGroupOptions(uniqueSubServices);
      })
      .catch((error) => {
        console.error("Error fetching sub-services:", error);
      });
  };
  const handleSubServiceGroupChange = (selectedOptions) => {
    setSelectedSubServiceGroups(selectedOptions);

    // Fetch service items for all selected sub-service groups
    const subServiceIds = selectedOptions.map((option) => option.value);
    const serviceIds = selectedServiceGroups.map((option) => option.value);

    Promise.all(serviceIds.flatMap((serviceId) => subServiceIds.map((subServiceId) => dispatch(getServiceItems({ serviceId, subServiceId })).unwrap())))
      .then((responses) => {
        const allServiceItems = responses.flatMap((response) =>
          response.data.serviceItems.map((item) => ({
            value: item._id,
            label: extractString(item.title),
          })),
        );
        // Remove duplicates
        const uniqueServiceItems = Array.from(new Set(allServiceItems.map((i) => i.value))).map((value) => allServiceItems.find((i) => i.value === value));
        setServiceItemsOptions(uniqueServiceItems);
      })
      .catch((error) => {
        console.error("Error fetching service items:", error);
      });
  };

  const handleLanguageChange = (selectedOptions) => {
    // Update the languages field with selected values
    setNurseData((prevData) => ({
      ...prevData,
      languages: selectedOptions ? selectedOptions.map((option) => option.value) : [], // Ensure it's an array of values
    }));
  };

  const handlePhotoUpload = async ({ files }) => {
    if (files.length > 0) {
      const file = files[0];
      const imageURL = URL.createObjectURL(file);
      setUploadedImage(imageURL);
      setIsPhotoUploading(true);

      try {
        const uploadResponse = await dispatch(uploadMedia({ files: [file] })).unwrap();
        const profilePhoto = uploadResponse?.data?.urls?.[0] || "";

        setNurseData((prevData) => ({
          ...prevData,
          profilePhoto,
        }));
        setIsPhotoUploaded(Boolean(profilePhoto));
      } catch (error) {
        setUploadedImage(null);
        setIsPhotoUploaded(false);
        ToastPopup.error(error?.message || error || t("selectValidImage"));
      } finally {
        setIsPhotoUploading(false);
      }
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    const currentLang = selectedLang.value.toLowerCase(); // 'en' or 'vi'

    if (name === "firstName" || name === "lastName" || name === "address" || name === "designation") {
      const trimmedValue = value.trimStart();
      if (value.trim() === "" && value.includes(" ")) return;

      setNurseData((prevData) => ({
        ...prevData,
        [name]: {
          ...prevData[name],
          [currentLang]: trimmedValue,
        },
      }));
    } else if (name === "passportNumber") {
      const trimmedValue = value.replace(/\s/g, ""); // Remove all spaces
      const isValid = /^[A-Za-z0-9]*$/.test(trimmedValue); // Allow only alphanumeric characters

      if (isValid) {
        setNurseData((prevData) => ({
          ...prevData,
          [name]: trimmedValue,
        }));
      }
    } else if (name === "email") {
      // Remove spaces from email
      const trimmedEmail = value.replace(/\s/g, "");

      setNurseData((prevData) => ({
        ...prevData,
        [name]: trimmedEmail,
      }));
    } else if (name === "employeeID") {
      if (value.startsWith(" ")) return;

      setNurseData((prevData) => ({
        ...prevData,
        [name]: value.toUpperCase(),
      }));
    } else if (name === "phoneNumber") {
      const numericValue = value.replace(/\D/g, "").replace(/\s/g, "");
      setNurseData((prevData) => ({
        ...prevData,
        [name]: numericValue,
      }));
    } else if (name !== "languages") {
      // For non-languages fields, handle normally
      setNurseData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    // Exclude countryCode and alpha2code from nurseData
    const { countryCode, alpha2code, isActive, ...restNurseData } = nurseData;

    // Calculate total fields excluding countryCode and alpha2code
    const totalFields = Object.keys(restNurseData).length + 1; // +1 for photo upload

    // Calculate filled fields excluding countryCode and alpha2code
    const filledFields =
      Object.values(restNurseData).filter((val) => {
        if (typeof val === "object" && !Array.isArray(val) && val !== null) {
          return Object.values(val).every((v) => v.trim() !== "");
        }
        return (typeof val === "string" && val.trim() !== "") || (Array.isArray(val) && val.length > 0);
      }).length + (isPhotoUploaded ? 1 : 0); // Add 1 if photo is uploaded

    // Count filled specialization inputs
    let specializationFilledCount = 0;
    const serviceGroupFilled = selectedServiceGroups.length > 0;
    const subServiceGroupFilled = selectedSubServiceGroups.length > 0;
    const serviceItemFilled = selectedServiceItems.length > 0;

    if (serviceGroupFilled) specializationFilledCount++;
    if (subServiceGroupFilled) specializationFilledCount++;
    if (serviceItemFilled) specializationFilledCount++;

    // Total sections is the count of filled specialization inputs
    const totalSections = specializationFilledCount;

    // Ensure only two decimal places
    setProgress(parseFloat((((filledFields + totalSections) / (totalFields + serviceGroups.length * 3)) * 100).toFixed(2)));
  }, [nurseData, isPhotoUploaded, selectedServiceGroups, selectedSubServiceGroups, selectedServiceItems, serviceGroups]);

  const handleSubmit = () => {
    const serviceGroup = { selectedServiceGroups, selectedSubServiceGroups, selectedServiceItems };
    const isValid = validateCretaeNurse(nurseData, serviceGroup);

    const selectedSpecializations = serviceGroups.filter((group) => group.serviceItems).map((group) => group.serviceItems);
    const selectedServiceItemIds = selectedServiceItems.map((item) => item.value);
    const nursePayload = {
      ...nurseData,
      specialization: selectedSpecializations.length > 0 ? selectedSpecializations : selectedServiceItemIds,
    };
    if (isValid) {
      if (isPhotoUploading) {
        ToastPopup.error("Please wait for the image upload to finish.");
        return;
      }
      dispatch(postNurse(nursePayload));
    }
  };
  const toggleSwitch = () => {
    if (isOn) {
      setShowDeactivateModal(true);
      /* setIsOn(false);
      setNurseData((prevData) => ({
        ...prevData,
        isActive: false,
      })); */
    } else {
      setShowActivateModal(true);
      /* setIsOn(true);
      setNurseData((prevData) => ({
        ...prevData,
        isActive: true,
      })); */
    }
  };

  const handleCancelStatus = () => {
    setShowStatusModal(false);
  };

  /*const handleConfirmStatus = ({ startDate, endDate }) => {
    setInactiveRange({ startDate, endDate });
    setIsOn(false);
    setNurseData((prevData) => ({
      ...prevData,
      isActive: false,
    }));
    setShowStatusModal(false);
  };*/

  const handleConfirmDeactivate = () => {
    setIsOn(false);
    setNurseData((prevData) => ({
      ...prevData,
      isActive: false,
    }));
    setShowDeactivateModal(false);
  };

  const handleConfirmActivate = () => {
    setIsOn(true);
    setNurseData((prevData) => ({
      ...prevData,
      isActive: true,
    }));
    setShowActivateModal(false);
  };

  const countries = [
    { code: "+1", alpha2code: "US" },
    { code: "+91", alpha2code: "IN" },
    { code: "+84", alpha2code: "VN" },
  ];

  const sufix = [{ title: "mr" }, { title: "mrs" }, { title: "miss" }];
  const [selectedTitle, setSelectedTitle] = useState("mr");
  const [showTitle, setShowTitle] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("+91");
  const [showDropdown, setShowDropdown] = useState(false);

  const handleCountryChange = (code) => {
    const selectedCountryObj = countries.find((country) => country.code === code);

    if (selectedCountryObj) {
      setSelectedCountry(code);
      setShowDropdown(false);
      setNurseData((prevData) => ({
        ...prevData,
        countryCode: selectedCountryObj.code,
        alpha2code: selectedCountryObj.alpha2code, // Setting alpha2code
      }));
    }
  };

  const handleTitleChange = (title) => {
    setSelectedTitle(title);
    setShowTitle(false);
  };
  console.log(selectedServiceGroups);
  return (
    <div className="create-nurse-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="dp-heading-flex">
        <div className="manage-service-heading department-heading">{t("createNurse")}</div>
        <Widgets.NewSelectDropdown options={langOptions} big placeholder={t("selGrpName")} onChange={(i) => setSelectedLang(i)} selectedValue={selectedLang} />
      </div>
      <div className="create-nurse-grid-container">
        <div className="create-grid-item">
          <div className="create-grid-item-1">
            <div className="create-nurse-heading">{t("generalInfo")}</div>
            {/* Active/inactive toggle removed for Create Nurse */}
          </div>
          <hr className="create-nurse-hr" />
          <div className="create-nurse-general-information">
            <div className="create-nurse-general-information-1">
              <div className="create-nurse-general-information-1-section">
                <div className="create-nurse-general-information-1-heading">
                  {t("firstName")}
                  <span className="create-star">*</span>
                </div>
                <div className="create-nurse-general-information-1-input">
                  <div className="phone-input">
                    <div className="country-code-dropdown sufix-code" onClick={() => setShowTitle(!showTitle)}>
                      {t(selectedTitle)}
                      <FontAwesomeIcon icon={faChevronDown} />
                      <div className="vertical-line"></div>
                    </div>
                    {showTitle && (
                      <div className="dropdown-modal sufix-modal">
                        {sufix.map((titles) => (
                          <div key={titles.title} onClick={() => handleTitleChange(titles.title)} className="dropdown-item">
                            {t(titles.title)}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <input
                    type="text"
                    name="firstName"
                    placeholder={t("namePlaceholder") + ` (${selectedLang.value})`}
                    autoComplete="off"
                    value={nurseData.firstName[selectedLang.value.toLowerCase()]}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      if (e.key === " " && nurseData.firstName[selectedLang.value.toLowerCase()].trim() === "") {
                        e.preventDefault(); // Block space key if the input is empty
                      }
                    }}
                    className="create-input-field-name"
                  />
                </div>
              </div>
              <div className="create-nurse-general-information-1-section">
                <div className="create-nurse-general-information-1-heading">
                  {t("lastName")}
                  <span className="create-star">*</span>
                </div>
                <div className="create-nurse-general-information-1-input">
                  <input type="text" name="lastName" autoComplete="off" placeholder={t("lastnamePlaceholder") + ` (${selectedLang.value})`} className="create-input-field" value={nurseData.lastName[selectedLang.value.toLowerCase()]} onChange={handleChange} />
                </div>
              </div>
            </div>
            <div className="create-nurse-general-information-1">
              <div className="create-nurse-general-information-1-section">
                <div className="create-nurse-general-information-1-heading">
                  {t("emailId")}
                  <span className="create-star">*</span>
                </div>
                <div className="create-nurse-general-information-1-input">
                  <input type="text" name="email" autoComplete="off" placeholder={t("emailPlaceholder")} className="create-input-field" value={nurseData.email} onChange={handleChange} />
                </div>
                {errors.email && <span className="error-message">{errors.email}</span>}
              </div>
              <div className="create-nurse-general-information-1-section">
                <div className="create-nurse-general-information-1-heading">
                  {t("dob")}
                  <span className="create-star">*</span>
                </div>
                <div className="create-nurse-general-information-1-input">
                  <input
                    type="date"
                    name="dateOfBirth"
                    placeholder={t("dobPlaceholder")}
                    className="create-input-field"
                    value={nurseData.dateOfBirth ? new Date(nurseData.dateOfBirth).toISOString().split("T")[0] : ""}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="create-nurse-general-information-1">
              <div className="create-nurse-general-information-1-section">
                <div className="create-nurse-general-information-1-heading">
                  {t("employeeId")}
                  <span className="create-star">*</span>
                </div>
                <div className="create-nurse-general-information-1-input">
                  <input
                    type="text"
                    name="employeeID"
                    autoComplete="off"
                    placeholder={t("nationalIdPlaceholder")}
                    className="create-input-field"
                    value={nurseData.employeeID}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="create-nurse-general-information-1-section">
                <div className="create-nurse-general-information-1-heading">
                  {t("phoneNumber")}
                  <span className="create-star">*</span>
                </div>
                <div className="create-nurse-general-information-1-input">
                  <div className="phone-input">
                    <div className="country-code-dropdown" onClick={() => setShowDropdown(!showDropdown)}>
                      {selectedCountry}
                      <FontAwesomeIcon icon={faChevronDown} />
                      <div className="vertical-line"></div>
                    </div>
                    {showDropdown && (
                      <div className="dropdown-modal">
                        {countries.map((country) => (
                          <div key={country.code} onClick={() => handleCountryChange(country.code)} className="dropdown-item">
                            {country.name} ({country.code})
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <input
                    type="text"
                    id="phoneNumber"
                    name="phoneNumber"
                    autoComplete="off"
                    placeholder={t("phonePlaceholder")}
                    className="create-input-field-name"
                    required
                    value={nurseData.phoneNumber}
                    onChange={handleChange}
                  />
                </div>
                {errors.phoneNumber && <span className="error-message">{errors.phoneNumber}</span>}
              </div>
            </div>
            <div className="create-nurse-general-information-1">
              <div className="create-nurse-general-information-1-section">
                <div className="create-nurse-general-information-1-heading">
                  {t("gender")}
                  {/* <span className="create-star">*</span> */}
                </div>
                <div className="create-nurse-general-information-1-input-gender">
                  <div className="input-gender-section">
                    <input type="radio" id="male" name="gender" value="Male" checked={nurseData.gender === "Male"} onChange={handleChange} required />
                    <label htmlFor="male">{t("male")}</label>
                  </div>
                  <div className="input-gender-section">
                    <input type="radio" id="female" name="gender" value="Female" checked={nurseData.gender === "Female"} onChange={handleChange} required />
                    <label htmlFor="female">{t("female")}</label>
                  </div>
                </div>
              </div>
              <div className="create-nurse-general-information-1-section">
                <div className="create-nurse-general-information-1-heading">
                  {t("designation")}
                  <span className="create-star">*</span>
                </div>
                <div className="create-nurse-general-information-1-input">
                  <input
                    type="text"
                    name="designation"
                    autoComplete="off"
                    placeholder={`${t("jobTitle")} (${selectedLang.value})`}
                    className="create-input-field"
                    value={nurseData.designation[selectedLang.value.toLowerCase()]}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="create-nurse-general-information-1">
              <div className="create-nurse-general-information-1-section">
                <div className="create-nurse-general-information-1-heading">
                  {t("language")}
                  <span className="create-star">*</span>
                </div>
                <div className="create-nurse-general-information-1-input">
                  <Select
                    id="languages"
                    name="languages"
                    placeholder={t("selectLang")}
                    required
                    isMulti
                    options={[
                      { value: "English", label: t("english") },
                      { value: "Vietnamese", label: t("vietnamese") },
                    ]}
                    className="basic-multi-select "
                    classNamePrefix="select"
                    value={[
                      { value: "English", label: t("english") },
                      { value: "Vietnamese", label: t("vietnamese") },
                    ].filter((option) => nurseData.languages.includes(option.value))}
                    onChange={handleLanguageChange}
                  />
                </div>
              </div>
              <div className="create-nurse-general-information-1-section">
                <div className="create-nurse-general-information-1-heading">
                  {t("address")}
                  <span className="create-star">*</span>
                </div>
                <div className="create-nurse-general-information-1-input">
                  <input
                    type="text"
                    name="address"
                    autoComplete="off"
                    placeholder={t("addressPlaceholder") + ` (${selectedLang.value})`}
                    className="create-input-field"
                    value={nurseData.address[selectedLang.value.toLowerCase()]}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="create-nurse-grid-item">
          <div className="create-grid-item-2">
            <div className="create-nurse-progress">{t("inProgress")}</div>
            <ProgressBarDynamic value={progress} />
          </div>
          <div className="create-grid-item-2">
            <div className="create-nurse-heading ">{t("photo")}</div>
            <hr className="create-nurse-photo-hr" />
            <div className="create-nurse-photo-upload">
              <div className="create-nurse-photo-container">
                <img src={uploadedImage || Icons.profileNurse} alt="Profile" />
              </div>
              <div className="select-card-container">
                <SelectCard onImageUpload={handlePhotoUpload} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="create-grid-item-3">
        <div className="">
          <h2 className="edit-nurse-heading">{t("specialization")}</h2>
          <hr className="edit-nurse-hr" />
          {serviceGroups.map((group, index) => (
            <div key={group.id} className="specialization-section">
              <div className="specialization-section-first a">

                <label className="edit-nurse-general-information-1-heading">{t("serviceGroup")}
                  <span className="create-star">*</span>
                </label>
                <div>
                  <MultiSelector options={serviceGroupOptions} selectedOptions={selectedServiceGroups} setSelectedOptions={handleServiceGroupChange} />
                </div>
              </div>

              <hr className="edit-nurse-hr" />
              <div className="specialization-section-first">
                <label className="edit-nurse-general-information-1-heading">{t("subServiceGroup")}
                  <span className="create-star">*</span>
                </label>
                <div
                  onClick={() => {
                    selectedServiceGroups.length === 0 && ToastPopup.error(t("pleaseSelectServiceGroupFirst"));
                  }}
                >
                  <MultiSelector
                    options={subServiceGroupOptions}
                    selectedOptions={selectedSubServiceGroups}
                    setSelectedOptions={handleSubServiceGroupChange} // Updated handler
                  />
                </div>
              </div>
              <hr className="edit-nurse-hr" />
              <div className="specialization-section-first">
                <label className="edit-nurse-general-information-1-heading">{t("serviceItem")}
                  <span className="create-star">*</span>
                </label>

                <div
                  onClick={() => {
                    selectedSubServiceGroups.length === 0 && ToastPopup.error(t("pleaseSelectSubServiceGroupFirst"));
                  }}
                >
                  <MultiSelector options={serviceItemsOptions} selectedOptions={selectedServiceItems} setSelectedOptions={setSelectedServiceItems} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="create-section-footer-buttons">
        <div className="create-section-footer-buttons-1">
          <button onClick={() => navigate(strings.navigation.nurseList)}>{t("cancel")}</button>
        </div>
        <div className="create-section-footer-buttons-2">
          <button onClick={handleSubmit}>{t("save")}</button>
        </div>
      </div>
      {/* Activation/Deactivation confirmation modals removed for Create Nurse */}
      {/* <Widgets.StatusChangeModal showModal={showStatusModal} onCancel={handleCancelStatus} onConfirm={handleConfirmStatus} /> */}
      {/* <Widgets.StatusChangeModal showModal={showStatusModal} onCancel={handleCancelStatus} onConfirm={handleConfirmStatus} /> */}
    </div>
  );
};

export default CreateNurse;
